import type { CardHooks } from "./registry";

/**
 * Spartacus, Undefeated — Pain Tolerance: for every 3 total damage received,
 * gain 1 focus. Tracked via totalHealthLost and nextFocusThreshold.
 *
 * NOTE: by the time this hook fires, the engine has already applied the
 * damage to `self.totalHealthLost`. We therefore compare the *current*
 * totalHealthLost to the threshold, not totalHealthLost + damageTaken.
 */
export const spartacusUndefeated: CardHooks = {
  onDamageTaken: (ctx) => {
    const { self, damageTaken } = ctx;
    if (!damageTaken || damageTaken <= 0) return {};
    let tokens = 0;
    let threshold = self.nextFocusThreshold;
    const log: string[] = [];
    while (self.totalHealthLost >= threshold) {
      tokens += 1;
      log.push(`Spartacus, Undefeated — Pain Tolerance: +1 focus (at ${threshold} dmg)`);
      threshold += 3;
    }
    if (tokens === 0) return {};
    return {
      selfPatch: { nextFocusThreshold: threshold },
      focusGrant: tokens,
      log,
    };
  },
};
